import React from 'react';
import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTCancelSubscriptionThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/CancelSubscription/DTCancelSubscriptionThenSendMacroNode/DTCancelSubscriptionThenSendMacroNode';

const CancelSubscriptionThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTCancelSubscriptionThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The subscription has been canceled.'}
    />
  );
};

export default CancelSubscriptionThenSendMacro;
